import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const IllustrationIcon = () => {
  const themeContext = useContext(ThemeContext);
  return (
    <svg height="246" width="520" fill="none" viewBox="0 0 520 246" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8766_7716)">
        <rect height="246" width="522" fill="url(#paint0_linear_8766_7716)" transform="translate(-1)" />
        <mask
          height="246"
          id="mask0_8766_7716"
          style={{ maskType: 'alpha' }}
          width="520"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <rect height="245" width="520" fill="url(#paint1_linear_8766_7716)" y="0.5" />
        </mask>
        <g mask="url(#mask0_8766_7716)">
          <circle cx="259" cy="134" opacity="0.2" r="169.5" stroke={themeContext.colors.graph[7]} />
          <circle cx="259" cy="134" opacity="0.3" r="125.5" stroke={themeContext.colors.graph[7]} />
          <circle cx="259" cy="134" opacity="0.4" r="83.5" stroke={themeContext.colors.graph[7]} />
          <circle cx="259" cy="134" opacity="0.05" r="213.5" stroke={themeContext.colors.primary.c500} />
        </g>
        <g>
          <circle cx="361.5" cy="62.5" fill="url(#paint2_linear_8766_7716)" r="16.5" />
        </g>
        <g>
          <circle cx="140" cy="167" fill="url(#paint4_linear_8766_7716)" r="20" />
        </g>
        <g>
          <circle
            cx="160.669"
            cy="57.6687"
            fill="url(#paint6_linear_8766_7716)"
            r="22.3674"
            transform="rotate(-20 160.669 57.6687)"
          />
        </g>
        <g>
          <circle cx="378" cy="173" fill="url(#paint8_linear_8766_7716)" r="16" />
        </g>
        <g>
          <circle
            cx="428.169"
            cy="111.169"
            fill="url(#paint10_linear_8766_7716)"
            r="20"
            transform="rotate(-10 428.169 111.169)"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M437.479 109.766L438.623 116.254C438.714 116.767 438.372 117.254 437.86 117.345L436.933 117.508L437.26 119.362L434.152 117.998L430.445 118.652C429.932 118.743 429.445 118.401 429.354 117.889L428.21 111.401C428.12 110.888 428.461 110.401 428.974 110.311L436.389 109.003C436.902 108.913 437.389 109.254 437.479 109.766ZM426.357 111.728L427.01 115.435L425.156 115.762L421.939 119.197L421.449 116.416L420.522 116.58C420.009 116.67 419.522 116.329 419.432 115.816L417.634 105.621C417.544 105.108 417.885 104.621 418.398 104.531L431.374 102.242C431.887 102.152 432.374 102.493 432.465 103.005L433.282 107.64L428.647 108.457C427.111 108.728 426.086 110.192 426.357 111.728Z"
            fill="url(#paint11_linear_8766_7716)"
            fillRule="evenodd"
          />
        </g>
        <g>
          <circle
            cx="91.2365"
            cy="99.2511"
            fill="url(#paint12_linear_8766_7716)"
            r="15.7371"
            transform="rotate(-10 91.2365 99.2511)"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M89.2562 89.4997C90.072 89.3558 90.85 89.9005 90.9938 90.7164L91.1069 91.3582C92.636 91.2354 94.0022 91.9069 94.9171 92.9401C95.4663 93.5604 95.4087 94.5084 94.7884 95.0576C94.1682 95.6068 93.2202 95.5493 92.671 94.9291C92.2676 94.4734 91.7372 94.2726 91.1962 94.368L90.2402 94.5366C90.2098 94.5439 90.1788 94.5504 90.1475 94.5559C90.1162 94.5614 90.085 94.566 90.0538 94.5695L88.8932 94.7742C88.0804 94.9175 87.5374 95.6916 87.681 96.5062C87.8003 97.1829 88.3679 97.6932 89.0498 97.7423L89.0499 97.7423L89.05 97.7423L93.1626 98.0373L93.1648 98.0375C95.2171 98.1877 96.9125 99.7113 97.271 101.745C97.6885 104.113 96.1707 106.377 93.848 106.907L93.9579 107.53C94.1017 108.346 93.5569 109.124 92.7411 109.268C91.9253 109.412 91.1473 108.867 91.0035 108.051L90.891 107.414C89.3584 107.536 87.9892 106.858 87.0756 105.824C86.5271 105.203 86.5859 104.255 87.2068 103.706C87.8277 103.158 88.7756 103.217 89.324 103.838C89.73 104.297 90.2638 104.499 90.8013 104.404L91.7066 104.244C91.7533 104.231 91.801 104.221 91.8497 104.212C91.8985 104.203 91.947 104.197 91.9953 104.193L93.1043 103.998C93.918 103.854 94.46 103.08 94.3166 102.266C94.1974 101.59 93.633 101.08 92.9464 101.03L92.9456 101.03L88.8349 100.735L88.8347 100.735C86.783 100.587 85.0849 99.06 84.7266 97.0273C84.3084 94.655 85.8306 92.3936 88.15 91.8647L88.0394 91.2374C87.8956 90.4216 88.4404 89.6436 89.2562 89.4997Z"
            fill="url(#paint13_linear_8766_7716)"
            fillRule="evenodd"
          />
        </g>
        <g>
          <rect height="88" width="88" fill="url(#paint14_linear_8766_7716)" rx="44" x="217" y="88" />
        </g>
        <path
          d="M368.645 62.8545C368.551 62.8237 368.442 62.8237 368.348 62.8237C367.896 62.8237 367.491 63.0702 367.257 63.4554L365.714 63.0856C365.916 61.8839 365.495 60.6977 364.685 59.8811L366.275 58.017C366.633 58.2481 367.07 58.3713 367.522 58.3713C367.584 58.3713 367.647 58.3713 367.709 58.3559C369.003 58.2481 369.954 57.1388 369.845 55.8601C369.751 54.6739 368.691 53.7649 367.522 53.7341C367.507 53.7341 367.507 53.7341 367.491 53.7341C367.475 53.7341 367.475 53.7341 367.46 53.7341C367.413 53.7341 367.366 53.7341 367.319 53.7341C366.025 53.8419 365.074 54.9512 365.184 56.2299C365.23 56.7537 365.449 57.2313 365.776 57.601L364.201 59.4806C363.827 59.2187 363.391 59.003 362.923 58.8952C362.627 58.8181 362.331 58.7873 362.034 58.7873C361.442 58.7873 360.881 58.926 360.366 59.1879L358.449 56.0296C358.729 55.7831 358.948 55.4596 359.041 55.0744C359.291 54.0884 358.667 53.087 357.669 52.8405C357.513 52.8097 357.373 52.7943 357.217 52.7943C356.375 52.7943 355.611 53.3643 355.409 54.2117C355.175 55.1823 355.783 56.1837 356.796 56.4302C356.952 56.461 357.092 56.4764 357.248 56.4764C357.482 56.4764 357.716 56.4302 357.934 56.3531L359.836 59.496C359.228 59.9428 358.745 60.559 358.496 61.3139L356.469 60.8209C356.438 60.1585 355.97 59.573 355.284 59.4036C355.159 59.3727 355.035 59.3573 354.91 59.3573C354.208 59.3573 353.569 59.8349 353.398 60.5282C353.195 61.3601 353.709 62.1921 354.536 62.3924C354.66 62.4232 354.785 62.4386 354.91 62.4386C355.549 62.4386 356.142 62.038 356.375 61.4218L358.355 61.8994C358.153 63.1164 358.574 64.3027 359.384 65.1192L357.482 67.3531C357.202 67.1837 356.874 67.0912 356.531 67.0912C356.484 67.0912 356.422 67.0912 356.375 67.0912C355.346 67.1683 354.583 68.0618 354.66 69.0786C354.738 70.0492 355.565 70.7733 356.516 70.7733C356.562 70.7733 356.625 70.7733 356.672 70.7733C357.7 70.6963 358.464 69.8027 358.386 68.7859C358.355 68.3853 358.199 68.031 357.95 67.7383L359.852 65.5198C360.226 65.7817 360.663 65.9974 361.13 66.1052C361.426 66.1823 361.723 66.2131 362.019 66.2131C362.611 66.2131 363.173 66.0744 363.687 65.8125L365.62 68.9708C365.34 69.2173 365.121 69.5408 365.028 69.926C364.778 70.912 365.402 71.9134 366.4 72.1599C366.556 72.1907 366.696 72.2061 366.852 72.2061C367.694 72.2061 368.457 71.636 368.66 70.7887C368.91 69.8027 368.286 68.8013 367.288 68.5548C367.132 68.524 366.992 68.5086 366.836 68.5086C366.602 68.5086 366.368 68.5548 366.15 68.6318L364.233 65.5044C364.841 65.0576 365.324 64.4414 365.573 63.6865L367.101 64.0562C367.101 64.6262 367.475 65.1346 368.052 65.2733C368.146 65.3041 368.255 65.3041 368.348 65.3041C368.91 65.3041 369.424 64.919 369.564 64.3643C369.736 63.7019 369.315 63.024 368.645 62.8545Z"
          fill="url(#paint3_linear_8766_7716)"
          opacity="0.3"
        />
        <path
          d="M150.334 165.662C150.164 165.554 148.818 164.749 148.284 164.504L147.623 162.904C147.819 162.375 148.197 160.892 148.263 160.634C148.29 160.517 148.286 160.394 148.252 160.279C148.219 160.163 148.156 160.058 148.071 159.973L147.028 158.936C146.943 158.85 146.838 158.788 146.722 158.754C146.606 158.721 146.484 158.717 146.367 158.744C146.17 158.789 144.66 159.171 144.097 159.384L142.497 158.723C142.264 158.211 141.481 156.899 141.338 156.672C141.275 156.569 141.186 156.483 141.081 156.424C140.975 156.365 140.856 156.333 140.735 156.333H139.267C139.146 156.333 139.028 156.364 138.922 156.422C138.817 156.48 138.727 156.564 138.663 156.666C138.554 156.837 137.75 158.183 137.505 158.716L135.905 159.378C135.376 159.181 133.893 158.804 133.635 158.738C133.517 158.711 133.395 158.715 133.279 158.748C133.164 158.782 133.058 158.844 132.973 158.93L131.937 159.973C131.851 160.058 131.788 160.163 131.755 160.278C131.721 160.394 131.718 160.517 131.745 160.634C131.789 160.83 132.171 162.341 132.385 162.904L131.723 164.504C131.211 164.736 129.899 165.519 129.673 165.662C129.57 165.725 129.484 165.814 129.425 165.92C129.365 166.026 129.334 166.145 129.334 166.266V167.732C129.334 167.852 129.365 167.971 129.423 168.076C129.481 168.182 129.565 168.271 129.667 168.335C129.837 168.444 131.184 169.248 131.717 169.494L132.378 171.094C132.182 171.623 131.804 173.106 131.738 173.364C131.712 173.481 131.715 173.603 131.749 173.719C131.783 173.835 131.845 173.94 131.93 174.025L132.967 175.062C133.052 175.147 133.157 175.21 133.273 175.244C133.389 175.277 133.511 175.281 133.628 175.254C133.825 175.209 135.335 174.827 135.898 174.614L137.498 175.275C137.731 175.787 138.514 177.099 138.657 177.325C138.72 177.43 138.81 177.517 138.917 177.576C139.024 177.636 139.144 177.667 139.267 177.667H140.732C140.853 177.667 140.971 177.636 141.077 177.578C141.183 177.52 141.272 177.436 141.336 177.334C141.445 177.163 142.249 175.817 142.495 175.284L144.095 174.622C144.624 174.819 146.106 175.196 146.364 175.262C146.482 175.289 146.604 175.285 146.72 175.252C146.835 175.218 146.941 175.156 147.026 175.07L148.063 174.034C148.148 173.949 148.211 173.843 148.244 173.728C148.278 173.612 148.281 173.49 148.255 173.372C148.21 173.176 147.828 171.666 147.615 171.102L148.276 169.502C148.788 169.27 150.1 168.487 150.326 168.344C150.431 168.28 150.517 168.191 150.577 168.084C150.637 167.977 150.668 167.856 150.667 167.734V166.266C150.668 166.145 150.638 166.026 150.58 165.921C150.522 165.815 150.437 165.726 150.334 165.662ZM140.001 171.644C139.081 171.643 138.183 171.37 137.419 170.858C136.655 170.347 136.06 169.62 135.709 168.771C135.358 167.921 135.266 166.986 135.447 166.085C135.627 165.183 136.07 164.355 136.721 163.706C137.372 163.056 138.2 162.614 139.102 162.436C140.004 162.257 140.939 162.35 141.788 162.703C142.637 163.055 143.362 163.652 143.872 164.417C144.382 165.182 144.654 166.081 144.653 167C144.651 168.232 144.159 169.413 143.287 170.284C142.415 171.154 141.233 171.644 140.001 171.644Z"
          fill="url(#paint5_linear_8766_7716)"
          opacity="0.3"
        />
        <path
          d="M160.323 55.0066C157.787 55.3903 155.421 53.646 155.037 51.1106C154.654 48.5753 156.398 46.209 158.933 45.8253C161.469 45.4417 163.835 47.186 164.219 49.7213C164.602 52.2567 162.858 54.623 160.323 55.0066ZM160.453 56.0257C156.964 56.5536 154.217 59.0336 153.025 62.2778C152.121 64.7398 154.081 67.3767 156.538 67.0048L167.44 65.3552C169.897 64.9833 170.99 61.8845 169.397 59.8004C167.299 57.0541 163.941 55.4979 160.453 56.0257Z"
          fill="url(#paint7_linear_8766_7716)"
          fillRule="evenodd"
          opacity="0.3"
        />
        <path
          d="M387.424 173.7C385.608 171.178 382.904 169.486 379.803 168.939C376.702 168.393 373.582 169.057 371.012 170.806L369.681 168.958C372.757 166.881 376.486 166.077 380.192 166.73C383.898 167.384 387.13 169.396 389.308 172.418L387.424 173.7ZM386.364 174.405C384.751 172.165 382.346 170.659 379.585 170.173C376.825 169.686 374.049 170.278 371.767 171.831L373.099 173.679C374.893 172.458 377.059 172.005 379.196 172.382C381.332 172.758 383.232 173.928 384.481 175.686L386.364 174.405ZM383.437 176.413C381.244 173.369 376.933 172.609 373.832 174.719L375.163 176.568C377.223 175.166 380.097 175.672 381.554 177.694L383.437 176.413ZM380.449 178.43C379.416 176.995 377.392 176.638 375.949 177.636L377.813 180.224L380.449 178.43Z"
          fill="url(#paint9_linear_8766_7716)"
          opacity="0.3"
        />
        <path
          d="M251.607 112.164L255.366 109.988L260.015 112.68V120.855V125.713V134.423V140.746V151.357L255.425 154.014L244.906 147.924V142.698L249.645 139.955L254.381 142.696V146.571C253.925 146.888 253.63 147.415 253.63 148.012C253.63 148.98 254.412 149.766 255.38 149.766C256.347 149.766 257.131 148.98 257.131 148.012C257.131 147.402 256.82 146.864 256.349 146.549V142.649C256.349 141.96 256.008 141.369 255.413 141.024L251.605 138.82L255.413 136.615C256.008 136.271 256.349 135.68 256.349 134.991V122.962C256.82 122.648 257.131 122.111 257.131 121.5C257.131 120.53 256.347 119.745 255.38 119.745C254.412 119.745 253.63 120.53 253.63 121.5C253.63 122.097 253.925 122.625 254.381 122.941V134.939L243.922 140.994L238.968 138.126V126.265L243.919 123.398L248.622 126.121V131.434L244.846 133.62C244.615 133.508 244.356 133.444 244.081 133.444C243.115 133.444 242.332 134.23 242.332 135.2C242.332 136.17 243.115 136.955 244.081 136.955C245.006 136.955 245.764 136.237 245.828 135.326L250.101 132.853L250.592 132.568V132V125.554V124.987L250.101 124.701L244.906 121.695V116.044L249.643 113.302L253.633 115.612C253.699 116.523 254.454 117.242 255.38 117.242C256.347 117.242 257.131 116.456 257.131 115.486C257.131 114.516 256.347 113.731 255.38 113.731C255.106 113.731 254.848 113.795 254.615 113.906L251.607 112.164ZM261.984 151.357V140.746V134.423V125.713V120.855V112.68L266.633 109.988L270.392 112.164L267.384 113.906C267.153 113.795 266.894 113.731 266.619 113.731C265.653 113.731 264.869 114.516 264.869 115.486C264.869 116.456 265.653 117.242 266.619 117.242C267.544 117.242 268.301 116.523 268.366 115.612L272.355 113.302L277.093 116.044V121.695L271.9 124.701L271.406 124.987V125.554V132V132.568L271.9 132.853L276.171 135.326C276.235 136.237 276.992 136.955 277.917 136.955C278.883 136.955 279.668 136.17 279.668 135.2C279.668 134.23 278.883 133.444 277.917 133.444C277.644 133.444 277.384 133.508 277.153 133.62L273.376 131.434V126.121L278.08 123.398L283.03 126.265V138.126L278.078 140.994L267.62 134.939V122.941C268.074 122.625 268.37 122.097 268.37 121.5C268.37 120.53 267.586 119.745 266.619 119.745C265.653 119.745 264.869 120.53 264.869 121.5C264.869 122.111 265.178 122.648 265.649 122.962V134.991C265.649 135.68 265.991 136.271 266.586 136.615L270.393 138.82L266.586 141.024C265.991 141.369 265.649 141.96 265.649 142.649V146.549C265.178 146.864 264.869 147.402 264.869 148.012C264.869 148.98 265.653 149.766 266.619 149.766C267.586 149.766 268.37 148.98 268.37 148.012C268.37 147.415 268.074 146.888 267.62 146.571V142.696L272.354 139.955L277.093 142.698V147.924L266.574 154.014L261.984 151.357ZM265.701 108.258L261 110.979L256.298 108.258C255.704 107.914 255.021 107.914 254.426 108.258L243.874 114.368C243.279 114.712 242.937 115.305 242.937 115.993V121.697L237.935 124.593C237.339 124.938 237 125.529 237 126.218V138.177C237 138.866 237.339 139.459 237.935 139.802L242.937 142.698V147.97C242.937 148.659 243.279 149.251 243.874 149.596L254.491 155.741C255.084 156.086 255.766 156.086 256.361 155.741L261 153.057L265.637 155.741C266.232 156.086 266.914 156.086 267.509 155.741L278.126 149.596C278.72 149.251 279.061 148.659 279.061 147.97V142.698L284.064 139.802C284.66 139.459 285 138.866 285 138.177V126.218C285 125.529 284.66 124.938 284.064 124.593L279.061 121.697V115.993C279.061 115.305 278.72 114.712 278.126 114.368L267.572 108.258C267.275 108.086 266.956 108 266.637 108C266.317 108 265.998 108.086 265.701 108.258Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_8766_7716" gradientUnits="userSpaceOnUse" x1="261" x2="261" y1="0" y2="246">
          <stop stopColor={themeContext.colors.primaryLight} />
          <stop offset="1" stopColor={themeContext.colors.primaryLight} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="260"
          x2="260"
          y1="169.5"
          y2="245.5"
        >
          <stop />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="360.537"
          x2="360.537"
          y1="46"
          y2="79"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor={themeContext.colors.primary.c050} />
        </linearGradient>
        <linearGradient
          id="paint3_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="367.846"
          x2="353.884"
          y1="75.1924"
          y2="50.4424"
        >
          <stop stopColor={themeContext.colors.modal.startGradient} />
          <stop offset="1" stopColor={themeContext.colors.modal.endGradient} />
        </linearGradient>
        <linearGradient
          id="paint4_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="138.833"
          x2="138.833"
          y1="147"
          y2="187"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor={themeContext.colors.primary.c050} />
        </linearGradient>
        <linearGradient
          id="paint5_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="143.501"
          x2="133.501"
          y1="181"
          y2="156"
        >
          <stop stopColor={themeContext.colors.modal.startGradient} />
          <stop offset="1" stopColor={themeContext.colors.modal.endGradient} />
        </linearGradient>
        <linearGradient
          id="paint6_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="159.364"
          x2="159.364"
          y1="35.3013"
          y2="80.0361"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor={themeContext.colors.primary.c050} />
        </linearGradient>
        <linearGradient
          id="paint7_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="161.446"
          x2="153.031"
          y1="67.6443"
          y2="47.8518"
        >
          <stop stopColor={themeContext.colors.modal.startGradient} />
          <stop offset="1" stopColor={themeContext.colors.modal.endGradient} />
        </linearGradient>
        <linearGradient
          id="paint8_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="377.067"
          x2="377.067"
          y1="157"
          y2="189"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor={themeContext.colors.primary.c050} />
        </linearGradient>
        <linearGradient
          id="paint9_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="380.409"
          x2="378.515"
          y1="182.51"
          y2="164.471"
        >
          <stop stopColor={themeContext.colors.modal.startGradient} />
          <stop offset="1" stopColor={themeContext.colors.modal.endGradient} />
        </linearGradient>
        <linearGradient
          id="paint10_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="427.002"
          x2="427.002"
          y1="91.1691"
          y2="131.169"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor={themeContext.colors.primary.c050} />
        </linearGradient>
        <linearGradient
          id="paint11_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="433"
          x2="421.001"
          y1="122.5"
          y2="103"
        >
          <stop stopColor={themeContext.colors.modal.startGradient} />
          <stop offset="1" stopColor={themeContext.colors.modal.endGradient} />
        </linearGradient>
        <linearGradient
          id="paint12_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="90.3185"
          x2="90.3185"
          y1="83.514"
          y2="114.988"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor={themeContext.colors.primary.c050} />
        </linearGradient>
        <linearGradient
          id="paint13_linear_8766_7716"
          gradientUnits="userSpaceOnUse"
          x1="93.2574"
          x2="88.9302"
          y1="111.545"
          y2="88.2189"
        >
          <stop stopColor={themeContext.colors.modal.startGradient} />
          <stop offset="1" stopColor={themeContext.colors.modal.endGradient} />
        </linearGradient>
        <linearGradient id="paint14_linear_8766_7716" gradientUnits="userSpaceOnUse" x1="217" x2="305" y1="88" y2="176">
          <stop stopColor={themeContext.colors.modal.endGradient} />
          <stop offset="1" stopColor={themeContext.colors.modal.startGradient} />
        </linearGradient>
        <clipPath id="clip0_8766_7716">
          <rect height="246" width="522" fill="white" transform="translate(-1)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IllustrationIcon;
